export const isDesktop = state => state.isDesktop;
export const menu = state => state.menu;
